import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { platform } from 'app-components/utils/core';

import { useGlobalSuppressAuthDialog } from 'components/Dialogs/AuthDialog';
import ChromebookFreeTrialPage from 'containers/ChromebookFreeTrialPage/loadable';

const UnauthenticatedHomePage = (_props) => {
  const [isChromebook, setIsChromebook] = useState(false);
  const playBilling = useSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'playBilling'));
  const showChromebookFreeTrialPage = useMemo(() => isChromebook && playBilling, [isChromebook, playBilling]);
  const [, setGlobalSuppressAuthDialog] = useGlobalSuppressAuthDialog();

  const getStarted = useCallback(() => {
    setGlobalSuppressAuthDialog(false);
  }, [setGlobalSuppressAuthDialog]);

  useEffect(() => {
    (async () => {
      const chromebook = await platform.isChromebook();
      setIsChromebook(chromebook);
    })();
  }, []);

  useEffect(() => {
    if (showChromebookFreeTrialPage) {
      setGlobalSuppressAuthDialog(true);
    } else {
      getStarted();
    }
  }, [getStarted, setGlobalSuppressAuthDialog, playBilling, isChromebook, showChromebookFreeTrialPage]);

  return showChromebookFreeTrialPage ? <ChromebookFreeTrialPage /> : null;
};

export default React.memo(UnauthenticatedHomePage);
